import * as qs from 'query-string';
import isEmpty from 'lodash/isEmpty';

import getCookie from './cookies';
import isBrowser from '../isBrowser';

const withCookieUrlParams = (url?: string, cookies?: string[]) => {
  if (!url) return;

  const defaultCookies = ['userInAbmCampaign'];
  let urlParams = {};
  let urlFragmentIdentifier: string | undefined = '';
  const linkValues = qs.parseUrl(url || '', { parseFragmentIdentifier: true });
  const allCookies = [...defaultCookies, ...cookies!];

  if (isBrowser()) {
    const { search } = window.location;
    const urlQueryParams = qs.parse(search);
    urlParams = { ...linkValues?.query, ...urlQueryParams };
    urlFragmentIdentifier = linkValues?.fragmentIdentifier;
  }

  const setCookies = allCookies.reduce((previous, cookie) => {
    const cookieValue = getCookie(cookie);
    if (cookieValue) {
      return {
        ...previous,
        [cookie]: getCookie(cookie),
      };
    }

    return previous;
  }, {});

  const allUrlParams = { ...setCookies, ...urlParams };
  return `${linkValues?.url}${!isEmpty(allUrlParams) ? `?${qs.stringify(allUrlParams)}` : ''}${
    urlFragmentIdentifier ? `#${urlFragmentIdentifier}` : ''
  }`;
};

export default withCookieUrlParams;
